// The four sections of the pastoral handover register. One source of truth
// for both the data-entry checkboxes and the printed document, so a new item
// only has to be added here.
export const HANDOVER_SECTIONS = [
  {
    title: 'Administrative Transition',
    items: [
      { key: 'adminKeys', label: 'Church Keys & Parsonage Keys' },
      { key: 'adminRegisters', label: 'Official Files & Administrative Registers' },
      { key: 'adminLogin', label: 'System Logins, Email Accounts & Passwords' }
    ]
  },
  {
    title: 'Financial Transition',
    items: [
      { key: 'finCash', label: 'Physical Cash in Hand & Petty Cash Box' },
      { key: 'finBank', label: 'Bank Passbooks, Cheque Books & FDs' },
      { key: 'finPetty', label: 'Outstanding Bills & Financial Clearances' }
    ]
  },
  {
    title: 'Membership & Worship Registers',
    items: [
      { key: 'memBaptism', label: 'Baptism & Confirmation Registers' },
      { key: 'memMarriage', label: 'Marriage & Burial Registers' },
      { key: 'memFamily', label: 'Church Membership & Family Registers' }
    ]
  },
  {
    title: 'Assets & Property',
    items: [
      { key: 'assetKeys', label: 'Asset Inventory Keys (Safe, Vehicles)' },
      { key: 'assetDocs', label: 'Property Documents, Court Cases, Insurance' },
      { key: 'assetVehicles', label: 'Church Vehicles & Garden/Cemetery Tools' }
    ]
  }
];

export const CHECKLIST_KEYS = HANDOVER_SECTIONS.flatMap((s) => s.items.map((i) => i.key));

export const emptyChecklist = () =>
  CHECKLIST_KEYS.reduce((acc, key) => ({ ...acc, [key]: false }), {});
